var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_11120)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_78_11120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4.00378,
    fill: "#5487FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6663C14.5889 22.6663 13.3473 22.1748 12.2753 21.1917C11.2029 20.2081 10.6667 18.8775 10.6667 17.1997C10.6667 16.0886 11.1084 14.8803 11.992 13.575C12.8751 12.2692 14.2111 10.8552 16 9.33301C17.7889 10.8552 19.1251 12.2692 20.0087 13.575C20.8918 14.8803 21.3333 16.0886 21.3333 17.1997C21.3333 18.8775 20.7971 20.2081 19.7247 21.1917C18.6527 22.1748 17.4111 22.6663 16 22.6663ZM16.1833 20.6663C16.3167 20.6552 16.4307 20.6026 16.5253 20.5083C16.6196 20.4137 16.6667 20.2997 16.6667 20.1663C16.6667 20.0108 16.6167 19.8859 16.5167 19.7917C16.4167 19.697 16.2889 19.6552 16.1333 19.6663C15.6778 19.6997 15.1944 19.5748 14.6833 19.2917C14.1722 19.0081 13.85 18.4941 13.7167 17.7497C13.6944 17.6275 13.636 17.5275 13.5413 17.4497C13.4471 17.3719 13.3389 17.333 13.2167 17.333C13.0611 17.333 12.9333 17.3912 12.8333 17.5077C12.7333 17.6246 12.7 17.7608 12.7333 17.9163C12.9222 18.9275 13.3667 19.6497 14.0667 20.083C14.7667 20.5163 15.4722 20.7108 16.1833 20.6663Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_78_11120",
    x: -16.0151,
    y: -12.0114,
    width: 64.0303,
    height: 64.0303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.00378
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.00757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101115 0 0 0 0 0.0619792 0 0 0 0 0.2125 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_78_11120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_78_11120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_11120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterWithBg);
export default __webpack_public_path__ + "static/media/water-with-bg.577cafc8f36c1a532d478a51f7fd2ddd.svg";
export { ForwardRef as ReactComponent };